<script>
  import { onMount } from "svelte";
  import request from 'superagent';
  import { createEventDispatcher } from 'svelte';
  import { topics as defaultStore } from '../stores.js'
  
  const dispatch = createEventDispatcher();
  
  export let form_id = 'e2ec2557-56f7-4b6d-8dc0-c0c0d26609d3';
  
  export let parent_id = null;
  export let title = "";
  export let topics_store = defaultStore;
  
  let topics = [];
  
  function commit() {
    let submit = request.post;
    submit(`/form/${form_id}`)
    .send({
      position: 1,
      parent_id: parent_id,
      title: title
    })
    .then(resp => {
      dispatch('topic', {
        id: resp.body.id,
        parent_id: parent_id,
        title: title,
        children: []
      })
    });
  }
  
  function init() {
    topics_store.subscribe(value => {
      if (value  != 'undefined' || !value)
        topics = value;
    });
  }
  
  onMount(init);
</script>
<form action='/form/{form_id}' class='form'>
<div class='row'>
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='topic-title'>Složka</label>
<input bind:value='{title}' class='form-control ui' id='topic-title' type='text'>
</fieldset>
<fieldset class='form-group col-12'>
<label class='form-text text-muted' for='topic-parent_id'>Nadsložka</label>
<select bind:value='{parent_id}' class='form-control ui' id='topic-parent_id'>
{#each topics as t}
<option value='{t.id}'>{t.title}</option>
{#each t.children as c}
<option value='{c.id}'>{t.title} &gt; {c.title}</option>
{#if c.children}{#each c.children as d}
<option value='{d.id}'>{t.title} &gt; {c.title} &gt; {d.title}</option>
{/each}{/if}
{/each}
{/each}
<option value=''></option>
</select>
</fieldset>
<div class='col-12'>
<button class='btn btn-outline-primary border-0' on:click|preventDefault='{commit}' type='submit'>
<i class='fa fa-check'></i>
vytvořit
</button>
</div>
</div>
</form>

